// ##############################
// // // Footer styles
// #############################

import { defaultFont, container } from "assets/jss/material-dashboard-react.jsx";

const footerStyle = theme => ({
  block: {
    color: "inherit",
    [theme.breakpoints.down("sm")]: {
      padding: "5px"
    },
    padding: "15px",
    textTransform: "uppercase",
    borderRadius: "3px",
    textDecoration: "none",
    position: "relative",
    display: "block",
    ...defaultFont,
    fontWeight: "500",
    fontSize: "12px"
  },

  // custom start
  
  footerContainer: {
    borderTop: "1px solid #e7e7e7",
  },
  titleLinks: {
    fontSize: "18px",
    // marginTop: "10px",
    marginBottom: "10px",
    marginLeft: "15px",
    lineHeight: "1.1",
    fontWeight: "400",
  },
  listLinks: {
    paddingTop: "5px",
    paddingBottom: "10px"
  },
  counter: {
    fontSize: "20px",
    textAlign: "center",
  },
  logo: {
    opacity: "0.9",
  },
  b: {
    fontSize: "20px",
    fontWeight: "500",
    textAlign: "center",
  },

  // custom end

  left: {
    float: "left!important",
    display: "block"
  },
  right: {
    padding: "15px 0",
    margin: "0",
    fontSize: "14px",
    float: "right!important"
  },
  footer: {
    bottom: "0",
    borderTop: "1px solid #e7e7e7",
    padding: "15px 0",
    ...defaultFont
  },
  container,
  a: {
    textDecoration: "none",
    backgroundColor: "transparent"
  },
  list: {
    marginBottom: "0",
    padding: "0",
    marginTop: "0"
  },
  inlineBlock: {
    [theme.breakpoints.down("sm")]: {
      paddingLeft: "0px",
      paddingRight: "0px",
    },
    [theme.breakpoints.down("md")]: {
      paddingLeft: "5px",
      paddingRight: "5px",
    },
    display: "inline-block",
    paddingTop: "0px",
    width: 'auto'
  }
});
export default footerStyle;



// WEBPACK FOOTER //
// ./src/assets/jss/material-dashboard-react/footerStyle.jsx